export function IsPC() {
  // 是否在移动端中
  var userAgentInfo = navigator.userAgent
  var Agents = ['Android', 'ios', 'Mobile', 'pad', 'pod', 'phone', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod', 'WebOS', 'Symbian', 'BlackBerry', 'IEMobile', 'MQQBrowser', 'wOSBrowser']
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > -1) {
      flag = false
      break
    }
  }
  return flag
}

export function IsWx() {
  // 是否在微信环境中
  var userAgentInfo = navigator.userAgent.toLowerCase()
  var flag = false
  if (userAgentInfo.match(/MicroMessenger/i) == "micromessenger") {
    flag = true
  } else {
    flag = false
  }
  return flag
}

export function debounce(fn, delay) {
    // 记录上一次的延时器
    var timer = null;
    var delay = delay || 200;
    return function() {
      var args = arguments;
      var that = this;
      // 清除上一次延时器
      clearTimeout(timer)
      timer = setTimeout(function() {
          fn.apply(that,args)
      }, delay);
    }
}

export function getFloatStr(num){  
    num += '';  
    num = num.replace(/[^0-9|\.]/g, ''); 

    if(/^0+/.test(num)) 
        num = num.replace(/^0+/, '');  
    if(!/\./.test(num)) 
        num += '.00';  
    if(/^\./.test(num))   
        num = '0' + num;  
    num += '00';      
    num = num.match(/\d+\.\d{2}/)[0];
    return num;
}

export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (typeof time === 'string') time = parseInt(time)
      if (('' + time).length === 10) time = parseInt(time) * 1000
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      if (key === 'a') {
        return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
      }
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
  }